import { usePayments } from '../../../context/PaymentsProvider';

import PayPalDescription from './PayPalDescription';

const PayPal = () => {
  const { paypal } = usePayments();

  if (!paypal) {
    return <></>;
  }

  return <PayPalDescription />;
};

export default PayPal;
